<template>
  <div class="comment">
    <div class="middle-left-2">
      <div class="middle-left-2-1 login" v-if="isLogin">
        <div class="typearea">
          <textarea :placeholder="`${$t('global.留点足迹')}...`" v-model="commentContent"></textarea>
          <span class="typecount">{{5000-commentContent.length}}</span>
        </div>
        <button class="comment-btn" @click="SubmitComment">{{$t('global.评论')}}</button>
      </div>
      <div class="middle-left-2-2">
        <div class="sum">{{$t('global.全部评论')}}：
          <span>{{totalItems}}</span>
        </div>
        <div class="comment-list">
          <div class="comment-item"
               v-for="(item,index) in commentList"
               :key="index">
            <div class="comment-item-content">
              <img class="comment-avatar"
                   :src="item.avatar | imageUrl('/static/profile_img_default.png',40,40)">
              <div class="comment-middle">
                <div class="comment-middle-1">
                  <span class="comment-name">{{item.nickName}}</span>
                  <span class="comment-time">{{item.date}}</span>
                </div>
                <div class="comment-middle-2">{{item.body}}</div>
              </div>
              <div class="comment-right">
                <div class="comment-count">
                        <span class="comment-count-icon"
                              v-on:click="showReply(item.id)"></span> {{item.replyCount}}
                </div>
                <div class="ding-count"
                     :class="{'ding-count-icon-active': (item.isLike == 1)}">
                        <span class="iconfont ding-count-icon"
                              @click="commentLike(item)">&#xe713;</span>
                  {{item.likeCount}}
                </div>
              </div>
              <a class="report commentReport"
                 @click="showReportC(item.id)">
                <span class="link-icon link-icon-jubao"></span>{{$t('global.举报')}}</a>
            </div>
            <div class="comment-reply"
                 v-if="showReplyId==item.id && item.userCommentReplyResponseList">
              <div class="comment-reply-list">
                <div class="comment-reply-item"
                     v-for="(subitem,subIndex) in item.userCommentReplyResponseList"
                     :key="subIndex">
                  <div class="comment-reply-middle-1">
                    <span class="comment-name">{{subitem.nickName}}</span>
                    <span class="comment-time">{{subitem.date}}</span>
                  </div>
                  <div class="comment-middle-2">{{subitem.body}}</div>
                </div>
              </div>
            </div>
            <div class="comment-reply-form"
                 v-if="showReplyId==item.id && isLogin">
              <div class="typearea">
                      <textarea :placeholder="$t('global.请输入回复内容')"
                                v-model="replyContent"></textarea>
                <span class="typecount">{{5000-replyContent.length}}</span>
              </div>
              <div class="reply-btns">
                <button class="reply-btn-cancel"
                        @click="cancelReply()">{{$t('global.取消')}}
                </button>
                <button class="reply-btn-yes"
                        @click="SubmitReplyComment()">{{$t('global.回复')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="comment-more"
           @click="getMoreComment()"
           v-if="commentTotalPage>commentPageIndex">{{$t('global.查看更多')}}
      </div>
    </div>
  </div>

</template>

<script type="text/ecmascript-6">
  export default {
    name: 'comment',
    data() {
      return {
        isLogin: true,
        commentContent: "",
        replyContent: "",
        showReplyId: 0,
        commentList: [],
        commentTotalPage: 1,
        commentPageIndex: 1,
        commentPageSize: 6,
        totalItems:0
      }
    },
    created() {
      this.getCommentList();
    },
    methods: {
      showReply(id) {
        if (this.showReplyId == id) {
          this.showReplyId = 0;
        } else {
          this.showReplyId = id;
        }
      },
      getCommentList() {
        var $this = this
        this.$http
          .get(
            '/api/activity/commentList?activityId=' +
            this.$route.params.id +
            '&pageIndex=' +
            this.commentPageIndex +
            '&pageSize=' +
            this.commentPageSize
          )
          .then(function(response) {
            if (response.data) {
              $this.commentList = $this.commentList.concat(response.data.userCommentResponsePageList.list)
              $this.totalItems=response.data.totalRecord
              $this.commentTotalPage = response.data.totalPage
            }
          })
      },
      getMoreComment() {
        this.commentPageIndex++
        this.getCommentList()
      },
      SubmitComment() {
        var $this = this
        if (!this.commentContent) {
          $this.$message.error(this.$t('global.回复内容不能为空'))
          return false
        }
        if (this.commentContent.length > 5000) {
          $this.$message.error(`${this.$t('global.回复内容不能超过')}5000${this.$t('global.字')}`)
          return false
        }
        this.$http
          .post('/api/u/comment/createComment', {
            domainId: this.$query.id,
            type: 1,
            content: this.commentContent
          })
          .then(function(response) {
            if (response) {
              $this.commentContent = ''
              $this.$message(response.message)
            }
          })
      },
      SubmitReplyComment() {
        var $this = this
        if (!this.replyContent) {
          $this.$message.error(this.$t('global.回复内容不能为空'))
          return false
        }
        if (this.replyContent.length > 5000) {
          $this.$message.error(`${this.$t('global.回复内容不能超过')}5000${this.$t('global.字')}`)
          return false
        }
        this.$http
          .post('/api/u/comment/createReply', {
            commentId: this.showReplyId,
            content: this.replyContent
          })
          .then(function(response) {
            if (response) {
              $this.replyContent = ''
              $this.$message(response.message)
            }
          })
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .middle-left-2 {
    -webkit-border-radius: 0.06rem;
    -moz-border-radius: 0.06rem;
    border-radius: 0.06rem;
    padding: 0.4rem 0.6rem 0;
    margin-top: 0.2rem;

    background-color: #fff;
    min-height: 1px;
    overflow: hidden;
    zoom: 1;
  }

  .middle-left-2-1 {
    height: 2.9rem;
    color: #000;
    font-size: 0.2rem;
    border-bottom: 1px solid #eeeeee;
    box-sizing: border-box;
    margin: 0 -0.6rem;
    overflow: hidden;
    zoom: 1;
  }

  .middle-left-2-1 a {
    color: #0060ff;
    text-decoration: underline #0060ff;
  }

  .middle-left-2-1.logout {
    text-align: center;
    padding-top: 1.38rem;
  }

  .middle-left-2-1.login .typearea {
    margin: 0 0.6rem;
    position: relative;
  }

  .middle-left-2-1.login .typearea textarea {
    height: 1.6rem;
    border: 1px solid #eeeeee;
    outline: none;
    background-color: #f9f9f9;
    font-size: 0.14rem;
    color: #999999;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0.18rem;
    resize: none;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
  }

  .middle-left-2-1.login .typearea .typecount {
    position: absolute;
    font-size: 0.14rem;
    color: #999999;
    right: 0.2rem;
    bottom: 0.12rem;
  }

  .comment-btn {
    padding: 0;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    width: 1.52rem;
    height: 0.46rem;
    line-height: 0.42rem;
    border: 0.02rem solid #0161ff;
    font-size: 0.18rem;
    color: #0161ff;
    text-align: center;
    background-color: #fff;
    -webkit-border-radius: 0.21rem;
    -moz-border-radius: 0.21rem;
    border-radius: 0.23rem;
    float: right;
    margin-right: 0.6rem;
    margin-top: 0.24rem;
  }

  .middle-left-2-2 {
    padding-top: 0.18rem;
  }

  .middle-left-2-2 .sum {
    font-size: 0.18rem;
    color: #777;
  }

  .middle-left-2-2 .sum span {
    font-size: 0.22rem;
    color: #333;
  }

  .comment-item {
    padding: 0.4rem 0;
    border-bottom: 1px solid #eeeeee;
    clear: both;
  }

  .comment-item-content {
    overflow: hidden;
    zoom: 1;
    position: relative;
  }

  .comment-avatar {
    width: 0.5rem;
    height: 0.5rem;
    float: left;
  }

  .comment-middle {
    margin-left: 0.18rem;
    float: left;
    width: 8rem;
    overflow: hidden;
    zoom: 1;
  }

  .comment-name {
    font-size: 0.18rem;
    color: #333;
    vertical-align: bottom;
    font-weight: bold;
    display: inline-block;
  }

  .comment-time {
    font-size: 0.16rem;
    color: #999;
    vertical-align: bottom;
  }

  .comment-middle-2 {
    font-size: 0.16rem;
    color: #777;
    margin-top: 0.15rem;
    line-height: 0.26rem;
  }

  .comment-right {
    position: absolute;
    right: 0;
    bottom: 0;
    font-size: 0.16rem;
    color: #777;
  }

  .comment-count, .ding-count {
    display: inline-block;
  }

  .comment-count-icon {
    display: inline-block;
    width: 0.18rem;
    height: 0.18rem;
    background: url("/static/vedio/comment.png") no-repeat center center;
    background-size: contain;
    margin-right: 0.1rem;
    vertical-align: top;
    cursor: pointer;
  }

  .ding-count-icon {
    display: inline-block;
    width: 0.18rem;
    height: 0.18rem;
    background: url("/static/vedio/ding.png") no-repeat center center;
    background-size: contain;
    margin: 0 0.1rem 0 0.2rem;
    vertical-align: top;
  }

  .comment-reply {
    clear: both;
    margin-left: 0.68rem;
    margin-top: 0.25rem;
    background-color: #f9f9f9;
    border: 1px solid #eeeeee;
    position: relative;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    padding: 0.22rem 0.19rem;
  }

  .comment-reply:before {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-right: 0.105rem solid transparent;
    border-left: 0.105rem solid transparent;
    border-top: none;
    border-bottom: 0.13rem solid #eeeeee;
    top: -0.13rem;
    left: 0.43rem;
  }

  .comment-reply:after {
    content: '';
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-right: 0.105rem solid transparent;
    border-left: 0.105rem solid transparent;
    border-top: none;
    border-bottom: 0.13rem solid #f9f9f9;
    top: -0.11rem;
    left: 0.43rem;
  }

  .comment-reply-form {
    margin-top: 0.2rem;
    padding-left: 0.68rem;
    position: relative;
  }

  .comment-reply-form textarea {
    border: 1px solid #eeeeee;
    background-color: #fff;
    -webkit-border-radius: 3px;
    -moz-border-radius: 3px;
    border-radius: 3px;
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0.19rem 0.2rem;
    font-size: 0.16rem;
    color: #777;
    resize: none;
    outline: none;
    height: 1.6rem;
  }

  .comment-reply-form .typearea {
    position: relative;
  }

  .comment-reply-form .typearea .typecount {
    position: absolute;
    font-size: 0.14rem;
    color: #999999;
    right: 0.2rem;
    bottom: 0.12rem;
  }

  .reply-btns {
    text-align: right;
    margin-top: 0.24rem;
  }

  .reply-btns button {
    width: 1.52rem;
    height: 0.46rem;
    line-height: 0.46rem;
    text-align: center;
    padding: 0;
    -webkit-border-radius: 0.23rem;
    -moz-border-radius: 0.23rem;
    border-radius: 0.23rem;
    border: 0.02rem solid;
    background-color: #fff;
    font-size: 0.18rem;
  }

  .reply-btns .reply-btn-cancel {
    border-color: #777777;
    color: #777777;
    margin-right: 0.2rem;
  }

  .reply-btn-yes {
    border-color: #0161ff;
    color: #0161ff;
  }

  .comment-more {
    height: 0.7rem;
    line-height: 0.7rem;
    text-align: center;
    font-size: 0.18rem;
    color: #0161ff;
  }

  .middle-right {
    width: 3.8rem;
    float: left;
    margin-left: 0.2rem;
    min-height: 1px;
  }

  .middle-right-1, .middle-right-2 {
    padding: 0.4rem 0.25rem 0.4rem 0.25rem;
    position: relative;
  }

  .middle-right-2 {
    margin-top: 0.2rem;
  }

  .middle-right-title {
    font-size: 0.3rem;
    color: #333333;
    font-weight: bold;
    margin-left: -0.25rem;
    padding-left: 0.25rem;
    position: relative;
  }

  .middle-right-title:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0.08rem;
    display: block;
    width: 0.06rem;
    height: 0.28rem;
    background-color: #0161ff;
    -webkit-border-radius: 0.03rem;
    -moz-border-radius: 0.03rem;
    border-radius: 0.03rem;
    margin-bottom: 0.3rem;
  }

  .biaoqian-item {
    display: inline-block;
    padding: 0.08rem 0.2rem;
    font-size: 0.18rem;
    color: #777777;
    margin: 0.1rem 0.05rem;
    border: 1px solid #dddddd;
    -webkit-border-radius: 0.3rem;
    -moz-border-radius: 0.3rem;
    border-radius: 0.3rem;
  }

  .middle-right-subtitle {
    position: absolute;
    right: 0.4rem;
    top: 0.5rem;
    font-size: 0.18rem;
    color: #777;
  }

  .middle-right-img {
    width: 3.3rem;
    height: 1.88rem;
    display: block;
    -webkit-border-radius: 0.06rem;
    -moz-border-radius: 0.06rem;
    border-radius: 0.06rem;
    margin-top: 0.3rem;
  }

  .shareCodeContainer {
    width: 5.8rem;
    margin: -12px;
    padding: 0.3rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .shareCodeContainer-row {
    line-height: 0.43rem;
    font-size: 0.16rem;
    color: #000000;
  }

  .share-tip {
    font-size: 0.2rem;
    display: inline-block;
    width: 0.7rem;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center;
    color: #fff;
    background-color: #0060ff;
    margin-right: 0.2rem;
  }

  .sharecode-content {
    width: 3.4rem;
    height: 0.3rem;
    line-height: 0.28rem;
    border: 0.01rem solid #999999;
    color: #999999;
    padding: 0 0.09rem;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    vertical-align: middle;
    margin: 0 0.15rem;
  }

  .sharecode-btn {
    font-size: 0.2rem;
    display: inline-block;
    width: 0.7rem;
    height: 0.3rem;
    line-height: 0.3rem;
    text-align: center;
    color: #fff;
    background-color: #0060ff;
    padding: 0;
    vertical-align: middle;
    border: none;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

</style>



// WEBPACK FOOTER //
// src/components/comment.vue